import { useEffect, useRef, useState } from "react";

export default function useMeasuring<T extends HTMLElement>() {
    const [size, setSize] = useState<{
        width: number;
        height: number;
    }>({
        width: 0,
        height: 0,
    });
    const ref = useRef<T>(null);

    useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            if (ref.current) {
                const { width, height } = entries[0].contentRect;
                setSize({ width, height });
            }
        });
        if (ref.current) {
            observer.observe(ref.current);
        }
        return () => observer.disconnect();
    }, [ref]);


    // useEffect(() => {
    //     const handleResize = () => {
    //         if (ref.current) {
    //             const oldWidth = ref.current.style.width;
    //             const oldHeight = ref.current.style.height;
    //             ref.current.style.width = "";
    //             ref.current.style.height = "";
    //             setSize({
    //                 width: ref.current.clientWidth,
    //                 height: ref.current.clientHeight,
    //             });
    //             ref.current.style.width = oldWidth;
    //             ref.current.style.height = oldHeight;
    //         }
    //     }
    //     handleResize();
    //     window.addEventListener("resize", handleResize);
    //     return () => window.removeEventListener("resize", handleResize);
    // }, [ref]);

    return [ref, size] as const;
}